/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { MaskDefinition } from 'src/app/_model/mask-definition';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class MaskDefinitionDaoService implements Resetable {
  public abstract saveMaskDefinitionsData(maskDefinitionData: any): Promise<void>;
  public abstract getMaskDefinitionsData(): Promise<any>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
